import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, LinearProgress, Snackbar, Alert } from '@mui/material';
//import CloseIcon from '@mui/icons-material/Close';
//import { COLORS } from '../../constants/colors';
import './BlastsCSS/DialogStyles.css';

const SendBlastDialog = ({ open, onClose, onConfirm, blast, userCount, onSendComplete }) => {
    const [isSending, setIsSending] = useState(false);
    const [progress, setProgress] = useState(0);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleSend = async () => {
        if (blast?.filteredUserCount === 0) {
            setSnackbarOpen(true);
            return;
        }

        console.log("Sending blast message...");
        setIsSending(true);
        setProgress(0);

        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 20;
            });
        }, 500);

        try {
            await onConfirm();
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Error sending blast:", error);
        } finally {
            clearInterval(interval);
            setProgress(100);
            setIsSending(false);
            onClose();
        }
    };

    // const handleSnackbarClose = (event, reason) => {
    //     if (reason === 'clickaway') {
    //         return;
    //     }
    //     setSnackbarOpen(false);
    // };

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            PaperProps={{
                className: 'dialog-container'
            }}
        >
            <DialogTitle>
                <Typography 
                    component="div"
                    className="dialog-title inter-custom"
                >
                    Warning: You are about to send a Blast
                </Typography>
            </DialogTitle>
            <DialogContent className="dialog-content">
                {blast ? (
                    <div className="text-center">
                        <Typography className="dialog-message">
                            Blast: {blast.message}
                        </Typography>
                        <Typography className={`dialog-message ${blast.filteredUserCount === 0 ? "text-red-500" : ""}`}>
                            Number of recipients: {blast.filteredUserCount || 0}
                        </Typography>
                        {blast.filteredUserCount === 0 && (
                            <Alert severity="warning" className="mt-2">
                                No users match your targeting criteria. Please adjust your targeting options.
                            </Alert>
                        )}
                    </div>
                ) : (
                    <Typography className="dialog-message">
                        No blast selected.
                    </Typography>
                )}
            </DialogContent>
            <DialogActions className="dialog-actions">
                <Button 
                    onClick={onClose}
                    className="dialog-button dialog-button-small dialog-button-secondary inter-custom"
                >
                    Cancel
                </Button>
                <Button 
                    onClick={handleSend}
                    className="dialog-button dialog-button-small dialog-button-primary inter-custom"
                    disabled={!blast || isSending || blast.filteredUserCount === 0}
                >
                    {isSending ? "Sending..." : "Send"}
                </Button>
            </DialogActions>
            {isSending && <LinearProgress variant="determinate" value={progress} />}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
            </Snackbar>
        </Dialog>
    );
};

export default SendBlastDialog;